import OrderEditPage from "../pages/crm/orders/OrderEditPage.vue";
import OrderProducts from "../pages/crm/orders/sidebarCards/ProductsCard.vue";
import OrderStatusesIndexPage from "../pages/crm/orderStatuses/OrderStatusesIndexPage.vue";
import OrderStatusCreatePage from "../pages/crm/orderStatuses/OrderStatusCreatePage.vue";
import OrderStatusEditPage from "../pages/crm/orderStatuses/OrderStatusEditPage.vue";
import ClientsIndexPage from "../pages/crm/clients/ClientsIndexPage.vue";
import ClientCreatePage from "../pages/crm/clients/ClientCreatePage.vue";
import ClientEditPage from "../pages/crm/clients/ClientEditPage.vue";
import IntegrationOrder from "../pages/crm/orders/sidebarCards/IntegrationOrderCard.vue";
import OrderCreatePage from "../pages/crm/orders/OrderCreatePage.vue";
import OrderSourceIndexPage from "../pages/crm/orderSource/OrderSourceIndexPage.vue";
import OrderSourceCreatePage from "../pages/crm/orderSource/OrderSourceCreatePage.vue";
import OrderSourceEditPage from "../pages/crm/orderSource/OrderSourceEditPage.vue";
import OrderExitDeclarations from "../pages/crm/orders/sidebarCards/ExitDeclarationCard.vue";
import DeliveriesIndexPage from "../pages/crm/orders/sidebarCards/DeliveriesIndexPage.vue";
import DeliveriesCreatePage from "../pages/crm/orders/sidebarCards/DeliveriesCreatePage.vue";
import DeliveryEditPage from "../pages/crm/orders/sidebarCards/DeliveryEditPage.vue";
import ExpensesIndexPage from "../pages/crm/orders/sidebarCards/OrderExpensesIndexPage.vue";
import OrderExpenseCreatePage from "../pages/crm/orders/sidebarCards/OrderExpenseCreatePage.vue";
import OrderExpenseEditPage from "../pages/crm/orders/sidebarCards/OrderExpenseEditPage.vue";
import OrderCustomFieldsIndexPage from "../pages/crm/orderCustomFields/OrderCustomFieldsIndexPage.vue";
import OrderCustomFieldsCreatePage from "../pages/crm/orderCustomFields/OrderCustomFieldsCreatePage.vue";
import OrderCustomFieldsEditPage from "../pages/crm/orderCustomFields/OrderCustomFieldsEditPage.vue";
import OrderCustomFieldsPage from "../pages/crm/orders/sidebarCards/OrderCustomFieldsPage.vue";
import OrderStatusesSettingsPage from "../pages/crm/deliveries/OrderStatusesSettingsPage.vue";
import AnalyticsIndexPage from "../pages/crm/analytics/AnalyticsIndexPage.vue";
import OrderClientCard from "../pages/crm/orders/sidebarCards/OrderClientCard.vue";
import OrderHistory from "../pages/crm/orders/sidebarCards/OrderHistoryCard.vue";
import SmsTemplatesIndexPage from "../pages/crm/sms_templates/SmsTemplatesIndexPage.vue";
import SmsTemplatesCreatePage from "../pages/crm/sms_templates/SmsTemplatesCreatePage.vue";
import SmsTemplatesEditPage from "../pages/crm/sms_templates/SmsTemplatesEditPage.vue";
import OrderSmsPage from "../pages/crm/orders/sidebarCards/OrderSmsPage.vue";
import OrderStatusOrderTable from "../pages/crm/orderStatuses/cards/OrderTableCard.vue";
import OrderStatusSmsTemplatesCard from "../pages/crm/orderStatuses/cards/OrderStatusSmsTemplatesCard.vue";
import OrderPaymentsPage from "../pages/crm/orders/sidebarCards/OrderPaymentsPage.vue";
import OrderPaymentCreatePage from "../pages/crm/orders/sidebarCards/OrderPaymentCreatePage.vue";
import OrderPaymentEditPage from "../pages/crm/orders/sidebarCards/OrderPaymentEditPage.vue";
import OrdersTablePage from "../pages/crm/orders/index/OrdersTablePage.vue";
import OrdersKanbanPage from "../pages/crm/orders/index/OrdersKanbanPage.vue";
import i18n from '../i18n';
import store from '../store';

const basePath = "/app/projects/:projectUuid/crm"

const crmRoutes = [
    {
        path: `${basePath}/orders/table`,
        name: 'OrdersTablePage',
        component: OrdersTablePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrdersTablePage") }
                ]
            }
        },
    },
    {
        path: `${basePath}/orders/kanban`,
        name: 'OrdersKanbanPage',
        component: OrdersKanbanPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrdersKanbanPage") }
                ]
            }
        },
    },
    {
        path: `${basePath}/orders/create`,
        name: 'OrderCreatePage',
        component: OrderCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrdersTablePage"), linkName: 'OrdersTablePage' },
                    { name: i18n.global.t("pages.OrderCreatePage") }
                ]
            }
        },
    },
    {
        path: `${basePath}/orders/:orderUuid`,
        name: 'OrderEditPage',
        component: OrderEditPage,
        redirect: { name: 'OrderProducts' },
        async beforeEnter(to) {
            await store.dispatch('route/fetchCrmOrder', {projectUuid: to.params.projectUuid, orderUuid: to.params.orderUuid});
        },
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrdersTablePage"), linkName: 'OrdersTablePage' },
                    { name: store.state.route.crmOrder?.id  }
                ]
            }
        },
        children: [
            {
                path: 'sms',
                name: 'OrderSmsPage',
                component: OrderSmsPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderSmsPage") }
                        ]
                    }
                }
            },
            {
                path: 'client',
                name: 'OrderClientCard',
                component: OrderClientCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderClientCard") }
                        ]
                    }
                }
            },
            {
                path: `products`,
                name: 'OrderProducts',
                component: OrderProducts,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderProducts") }
                        ]
                    }
                },
            },
            {
                path: `integration-order`,
                name: 'IntegrationOrder',
                component: IntegrationOrder,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.IntegrationOrder") }
                        ]
                    }
                }
            },
            {
                path: `exit-declarations`,
                name: 'OrderExitDeclarations',
                component: OrderExitDeclarations,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderExitDeclarations") }
                        ]
                    }
                }
            },
            {
                path: `deliveries`,
                name: 'OrderDeliveriesPage',
                component: DeliveriesIndexPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderDeliveriesPage") }
                        ]
                    }
                }
            },
            {
                path: `deliveries/create`,
                name: 'OrderDeliveriesCreatePage',
                component: DeliveriesCreatePage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderDeliveriesPage") },
                            { name: i18n.global.t("pages.OrderDeliveriesCreatePage") }
                        ]
                    }
                }
            },
            {
                path: `deliveries/:deliveryUuid`,
                name: 'OrderDeliveriesEditPage',
                component: DeliveryEditPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderDeliveriesPage") },
                            { name: i18n.global.t("pages.OrderDeliveriesEditPage") }
                        ]
                    }
                }
            },
            {
                path: `expenses`,
                name: 'OrderExpensesIndexPage',
                component: ExpensesIndexPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.ExpensesIndexPage") }
                        ]
                    }
                }, 
            },
            {
                path: `expenses/create`,
                name: 'OrderExpenseCreatePage',
                component: OrderExpenseCreatePage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.ExpensesIndexPage") },
                            { name: i18n.global.t("pages.OrderExpenseCreatePage") }
                        ]
                    }
                }
            },
            {
                path: `expenses/:orderExpenseUuid`,
                name: 'OrderExpenseEditPage',
                component: OrderExpenseEditPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.ExpensesIndexPage") },
                            { name: i18n.global.t("pages.OrderExpenseEditPage") }
                        ]
                    }
                },  
            },
            {
                path: `custom-fields`,
                name: 'OrderCustomFieldsPage',
                component: OrderCustomFieldsPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderCustomFieldsPage") }
                        ]
                    }
                }
            },
            {
                path: `history`,
                name: 'OrderHistory',
                component: OrderHistory,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderHistory") }
                        ]
                    }
                }
            },
            {
                path: `payments`,
                name: 'OrderPaymentsPage',
                component: OrderPaymentsPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderPaymentsPage") }
                        ]
                    }
                }
            },
            {
                path: `payments/create`,
                name: 'OrderPaymentCreatePage',
                component: OrderPaymentCreatePage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderPaymentsPage"), linkName: 'OrderPaymentsPage' },
                            { name: i18n.global.t("pages.OrderPaymentCreatePage") }
                        ]
                    }
                }
            },
            {
                path: `payments/:orderPaymentUuid/edit`,
                name: 'OrderPaymentEditPage',
                component: OrderPaymentEditPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderPaymentsPage"), linkName: 'OrderPaymentsPage' },
                            { name: i18n.global.t("pages.OrderPaymentEditPage") }
                        ]
                    }
                }
            }
        ]
    },
    {
        path: `${basePath}/order/statuses`,
        name: 'OrderStatusesPage',
        component: OrderStatusesIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderStatusesPage") }
                ]
            }
        }, 
    },
    {
        path: `${basePath}/order/statuses/create`,
        name: 'OrderStatusCreatePage',
        component: OrderStatusCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderStatusesPage"), linkName: "OrderStatusesPage" },
                    { name: i18n.global.t("pages.OrderStatusCreatePage") }
                ]
            }
        },
    },
    {
        path: `${basePath}/order/statuses/:orderStatusUuid`,
        name: 'OrderStatusEditPage',
        component: OrderStatusEditPage,
        redirect: { name: 'OrdersStatusOrderTable' },
        async beforeEnter(to) {
            try {
                await store.dispatch('route/fetchCrmOrderStatus', {projectUuid: to.params.projectUuid, orderStatusUuid: to.params.orderStatusUuid});
            } catch (error) {
                const status = error?.response?.status;

                if (status === 404) {
                    return { name: 'NotFoundPage' };
                }

                throw error;
            }
        },
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("sidebar.items.orders"), linkName: "OrderStatusesPage" },
                    { name: store.state.route.crmOrderStatus?.name }
                ]
            }
        },
        children: [
            {
                path: `orders`,
                name: 'OrdersStatusOrderTable',
                component: OrderStatusOrderTable,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderStatusesPage") }
                        ]
                    }
                }
            },
            {
                path: `sms-templates`,
                name: 'OrderStatusSmsTemplates',
                component: OrderStatusSmsTemplatesCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrderStatusesPage") }
                        ]
                    }
                }
            }
        ]
    },
    {
        path: `${basePath}/clients`,
        name: 'ClientsIndexPage',
        component: ClientsIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ClientsIndexPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/clients/create`,
        name: 'ClientCreatePage',
        component: ClientCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ClientsIndexPage") },
                    { name: i18n.global.t("pages.ClientCreatePage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/clients/:clientUuid`,
        name: 'ClientEditPage',
        component: ClientEditPage,
        async beforeEnter(to) {
            try {
                await store.dispatch('route/fetchCrmClient', {projectUuid: to.params.projectUuid, clientUuid: to.params.clientUuid});
            } catch (error) {
                const status = error?.response?.status;

                if (status === 404) {
                    return { name: 'NotFoundPage' };
                }

                throw error;
            }
        },
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.ClientsIndexPage"), linkName: 'ClientsIndexPage' },
                    { name: store.state.route.crmClient?.name }
                ]
            }
        }
    },
    {
        path: `${basePath}/orders/order-sources`,
        name: 'OrderSourceIndexPage',
        component: OrderSourceIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderSourceIndexPage") }
                ]
            }
        }
    },
    {
        name: 'OrderSourceCreatePage',
        path: `${basePath}/orders/order-sources/create`,
        component: OrderSourceCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderSourceIndexPage"), linkName: 'OrderSourceIndexPage' },
                    { name: i18n.global.t("pages.OrderSourceCreatePage") }
                ]
            }
        }
    },
    {
        name: 'OrderSourceEditPage',
        path: `${basePath}/orders/order-sources/:orderSourceUuid`,
        component: OrderSourceEditPage,
        async beforeEnter(to) {
            try {
                await store.dispatch('route/fetchCrmOrderSource', {projectUuid: to.params.projectUuid, orderSourceUuid: to.params.orderSourceUuid});
            } catch (error) {
                const status = error?.response?.status;

                if (status === 404) {
                    return { name: 'NotFoundPage' };
                }

                throw error;
            }
        },
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderSourceIndexPage"), linkName: 'OrderSourceIndexPage' },
                    { name: store.state.route.crmOrderSource?.name }
                ]
            }
        },
    },
    {
        path: `${basePath}/orders/custom-fields`,
        name: 'OrderCustomFieldsIndexPage',
        component: OrderCustomFieldsIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderCustomFieldsIndexPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/orders/custom-fields/create`,
        name: 'OrderCustomFieldsCreatePage',
        component: OrderCustomFieldsCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderCustomFieldsIndexPage"), linkName: 'OrderCustomFieldsIndexPage' },
                    { name: i18n.global.t("pages.OrderCustomFieldsCreatePage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/orders/custom-fields/:customFieldUuid`,
        name: 'OrderCustomFieldsEditPage',
        component: OrderCustomFieldsEditPage,
        async beforeEnter(to) {
            try {
                await store.dispatch('route/fetchCrmOrderCustomField', {projectUuid: to.params.projectUuid, orderCustomFieldUuid: to.params.customFieldUuid});
            } catch (error) {
                const status = error?.response?.status;

                if (status === 404) {
                    return { name: 'NotFoundPage' };
                }

                throw error;
            }
        },
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderCustomFieldsIndexPage"), linkName: 'OrderCustomFieldsIndexPage' },
                    { name: store.state.route.crmOrderCustomField?.name }
                ]
            }
        }
    },
    {
        path: `${basePath}/orders/settings`,
        name: 'OrderStatusesSettingsPage',
        component: OrderStatusesSettingsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.OrderStatusesPage"), linkName: "OrderStatusesPage" },
                    { name: i18n.global.t("pages.OrderStatusesSettingsPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/analytics`,
        name: 'AnalyticsIndexPage',
        component: AnalyticsIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.AnalyticsIndexPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/sms-templates`,
        name: 'SmsTemplatesIndexPage',
        component: SmsTemplatesIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.SmsTemplatesIndexPage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/sms-templates/create`,
        name: 'SmsTemplatesCreatePage',
        component: SmsTemplatesCreatePage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.SmsTemplatesIndexPage"), linkName: 'SmsTemplatesIndexPage' },
                    { name: i18n.global.t("pages.SmsTemplatesCreatePage") }
                ]
            }
        }
    },
    {
        path: `${basePath}/sms-templates/:smsTemplateUuid/edit`,
        name: 'SmsTemplatesEditPage',
        component: SmsTemplatesEditPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.SmsTemplatesIndexPage"), linkName: 'SmsTemplatesIndexPage' },
                    { name: i18n.global.t("pages.SmsTemplatesEditPage") }
                ]
            }
        }
    }
]

export default crmRoutes